export default __webpack_public_path__ + "static/media/Wifi - Grey.1de5ecfa.svg";